import { render, staticRenderFns } from "./DonutGlucoseZones.vue?vue&type=template&id=f747b68c&scoped=true"
import script from "./DonutGlucoseZones.vue?vue&type=script&lang=js"
export * from "./DonutGlucoseZones.vue?vue&type=script&lang=js"
import style0 from "./DonutGlucoseZones.vue?vue&type=style&index=0&id=f747b68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f747b68c",
  null
  
)

export default component.exports